import { NavLink } from 'react-router-dom'
import Footer from './Footer'

const links = [
  { to: '/', label: 'Projects' },
  { to: '/about', label: 'About' },
  { to: '/blog', label: 'Blog' },
]

function Navbar() {
  return (
    <header className='flex items-end justify-between px-6 sm:px-10 pt-6 lg:fixed lg:inset-y-0 lg:left-0 lg:flex-col lg:items-start lg:justify-start lg:px-8 lg:pt-12 lg:pb-12 lg:w-48 z-10'>
      <NavLink to='/' className='text-xl leading-tight'>
        jonghwi <br className='hidden lg:block' />
        kim
      </NavLink>
      <nav className='flex space-x-4 text-sm leading-6 lg:flex-col lg:space-x-0 lg:mt-6'>
        {links.map(({ to, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              isActive ? 'w-max text-gray-400' : 'w-max link no-underline'
            }
          >
            {label}
          </NavLink>
        ))}
      </nav>
      <div className='hidden lg:block lg:mt-auto'>
        <Footer />
      </div>
    </header>
  )
}

export default Navbar
